class Header {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const $html = $('html');
    const duration = Number($html.data('transition'));
    let scrollLocked = false;

    const onTouchMove = (e) => {
      if ($(e.target).closest('.l-header__content').length) return;
      e.preventDefault();
    };

    const lockBody = () => {
      if (scrollLocked) return;
      scrollLocked = true;
      scrollBanOpen();
      document.addEventListener('touchmove', onTouchMove, { passive: false });
    };

    const unlockBody = () => {
      if (!scrollLocked) return;
      scrollLocked = false;
      scrollBanClose();
      document.removeEventListener('touchmove', onTouchMove);
    };

    $('.js-header-trigger').on('click', function(){
      const willOpen = !$html.hasClass('is-header-open');

      if (willOpen) {
        lockBody();
        $html.addClass('is-header-open');
        $(this).attr('aria-expanded', 'true');
      } else {
        $html.removeClass('is-header-open');
        $(this).attr('aria-expanded', 'false');
        unlockBody();
        $('.js-header-accordion').attr('aria-expanded', 'false');
        $('.js-header-accordion').closest('.l-header__nav-item').removeClass('is-open');
        $('.l-header__subnav').slideUp(duration);
      }
    });

    $('.js-header-accordion').on('click', function(){
      const $item = $(this).closest('.l-header__nav-item');
      const willOpen = !$item.hasClass('is-open');

      $item.toggleClass('is-open');
      $(this).attr('aria-expanded', willOpen);
      $item.find('.l-header__subnav').slideToggle(duration);
    });

    $('.l-header__nav-link[href^="#"]').on('click', function(e){
      const href = this.getAttribute('href');
      const target = href ? document.querySelector(href) : null;

      if (!$html.hasClass('is-header-open') || !target) return;

      e.preventDefault();
      $html.removeClass('is-header-open');
      $('.js-header-trigger').attr('aria-expanded', 'false');
      unlockBody();
      $('.js-header-accordion').attr('aria-expanded', 'false');
      $('.js-header-accordion').closest('.l-header__nav-item').removeClass('is-open');
      $('.l-header__subnav').slideUp(duration);

      requestAnimationFrame(() => {
        target.scrollIntoView();
        if (history.replaceState) {
          history.replaceState(null, '', href);
        }
      });
    });
  }
}
